import React from "react";
import { Button, Header, Menu, Segment } from "semantic-ui-react";
import { IAssessment } from "../../Models/Assessment";
import PartnerLogoComponent from "../Admin/PartnerLogoComponent";

import { headerNavigation as topNav, navigationIcons as navIco } from "../../Components/Enums/NavigationEnums";
import styles from './ModuleOverviewHeader.module.css';

export interface ModuleOverviewHeaderProps {
  hideAssessment: () => void;
  assessment: IAssessment;
  domain: string;
  activeTab: string;
  menuNavigationEvent: (name: string) => void;
}

export const ModuleOverviewHeader: React.FC<ModuleOverviewHeaderProps> = ({
  hideAssessment,
  domain,
  activeTab,
  menuNavigationEvent,
}) => {
  
  return (
    <>
      <Segment attached='top' id={styles.modalOverviewHeaderHeader}>
        <Menu fluid tabular className={styles.modalOverviewHeaderMenuHeader} >
          <Menu.Menu className={styles.menuMenuLogo}>
            <Menu.Item className={styles.menuItemLogo}>
              <PartnerLogoComponent  />
            </Menu.Item>
          </Menu.Menu>
          <Menu.Menu position="right" className={styles.modalOverviewHeaderMenuMenuHeader}>
              <Menu.Item
                icon={navIco.OVERVIEW}
                name={topNav.OVERVIEW}
                role="overviewMenuTab"
                className={activeTab === topNav.OVERVIEW ? "selected" : ""}
                onClick={() => menuNavigationEvent(topNav.OVERVIEW)}
              />
              <Menu.Item
                icon={navIco.RESOURCES}
                name={topNav.RESOURCES}
                role="overviewMenuTab"
                className={activeTab === topNav.RESOURCES ? "selected" : ""}
                onClick={() => menuNavigationEvent(topNav.RESOURCES)}
              />
              <Menu.Item
                icon={navIco.DOCUMENTS}
                name={topNav.DOCUMENTS}
                role="overviewMenuTab"
                className={activeTab === topNav.DOCUMENTS ? "selected" : ""}
                onClick={() => menuNavigationEvent(topNav.DOCUMENTS)}
              />
            </Menu.Menu>
            <Menu.Item  className={styles.overviewMenuItemExitBtn}>
              <Button aria-label={topNav.EXIT} onClick={() => hideAssessment()}> { topNav.EXIT }</Button>
            </Menu.Item>
          </Menu>  
        <Header className={styles.overviewSubheaderModule}>
            { `${domain} ${activeTab}`}
        </Header>
    </Segment>
    </>
  );
};
